type ApiErrorLike = {
  response?: {
    data?: {
      message?: string | string[];
      error?: string;
      details?: string;
    };
    status?: number;
  };
  message?: string;
};

export const extractApiErrorMessage = (
  error: unknown,
  fallback = "Something went wrong. Please try again."
): string => {
  const err = error as ApiErrorLike;
  const data = err?.response?.data;
  const rawMessage = data?.message;

  const message =
    Array.isArray(rawMessage) && rawMessage.length > 0
      ? rawMessage.join(", ")
      : typeof rawMessage === "string" && rawMessage.trim()
        ? rawMessage
        : typeof data?.details === "string" && data.details.trim()
          ? data.details
          : typeof data?.error === "string" && data.error.trim()
            ? data.error
            : typeof err?.message === "string" && err.message.trim()
              ? err.message
              : fallback;

  return message.trim();
};

export const showUploadErrorAlert = (reason: string): void => {
  if (typeof window === "undefined") return;
  window.alert(`Upload failed:\n${reason}`);
};
